import { render } from "./SuperAdminListCompany.vue?vue&type=template&id=12234b82"
import script from "./SuperAdminListCompany.vue?vue&type=script&lang=js"
export * from "./SuperAdminListCompany.vue?vue&type=script&lang=js"

import "./SuperAdminListCompany.vue?vue&type=style&index=0&id=12234b82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__